import { I18n } from '@calendly/i18n'
import { Loader } from '@calendly/ui/components/loader'
import { Header, Body } from '@calendly/ui/components/popup'

export const Loading = () => (
  <>
    <Header
      title={I18n.t('publisher.billing.scheduled_downgrade.non_renewing_modal.title')}
    />
    <Body>
      <Loader />
    </Body>
  </>
)
